import React, { useEffect, useState } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Card, Alert } from "reactstrap";

import {
    resetGetViewConfigurationAdmin, getViewConfigurationAdminList
} from "../../redux/actions/getViewConfigurationAdminAction";
import {
    resetGetUpdateConfigurationAdmin, getUpdateConfigurationAdminList
} from "../../redux/actions/getUpdateConfigurationAdminAction";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import Layout from "../../components/Wrappers/Layout";
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Box
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import BackButton from "../../components/BackButton/BackButton";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
// import { getUpdateConfigurationAdminList } from "../../redux/actions/getUpdateConfigurationAdminAction";

function AdminUpdateConfiguration() {
    const regenerateTokenRes = useSelector(
        ({ regenerateToken }) => regenerateToken
    );

    var authToken = regenerateTokenRes.data.AuthToken;

    const location = useLocation();
    const dispatch = useDispatch();
    const role = location.search.split("?userId=")[1].split("&")[0];
    console.log(role, "role")
    const WalletOwnwerFromSearch = location.search.split("=")[2];

    const [isLoading, setIsLoading] = useState(false);
    const [getConfigViewStatus, setGetConfigViewStatus] = useState(false);
    const [getConfigViewRes, setGetConfigViewRes] = useState("");

    // Market Place
    const [walletRole, setWalletRole] = useState(role);
    const [dealRequired, setDealRequired] = useState("");
    const [orderMgtAllowed, setOrderMgtAllowed] = useState("");
    const [prdMgtAllowed, setPrdMgtAllowed] = useState("");
    const [orderSellReportAllowed, setorderSellReportAllowed] = useState("");
    const [isPromoCodeAllowed, setIsPromoCodeAllowed] = useState("");

    //Sign Up and Login
    const [merchantRequired, setMerchantRequired] = useState("");
    const [newDeviceCheckAllowed, setNewDeviceCheckAllowed] = useState("");
    const [changePasswordAllowed, setchangePasswordAllowed] = useState("");
    const [dealerMappingRequired, setDealerMappingRequired] = useState("");

    const [prefixAccountId, setPrefixAccountId] = useState("");
    const [customerCreationAllowed, setCustomerCreationAllowed] = useState("");
    const [emailAllowed, setEmailAllowed] = useState("");
    const [smsAllowed, setSmsAllowed] = useState("");

    const [businessSignupAllowed, setBusinessSignupAllowed] = useState("");
    const [maxUboCount, setmaxUboCount] = useState("");
    const [maxDirectorCount, setmaxDirectorCount] = useState("");
    const [autoFilledAllowed, setautoFilledAllowed] = useState("");

    const [addBankDuringSignUp, setaddBankDuringSignUp] = useState("");
    const [dateOfBirthRequired, setdateOfBirthRequired] = useState("");
    const [nationalityRequired, setnationalityRequired] = useState("");
    const [isCustCreation, setisCustCreation] = useState('');
    const [KycRequired, setKycRequired] = useState('');

    // Prepaid Card

    const [customerActivateCardRequired, setCustomerActivateCardRequired] =
        useState("");
    const [prepaidCardFeatureRequired, setprepaidCardFeatureRequired] =
        useState("");
    const [applyingPrepaidCardDuringSignUp, setapplyingPrepaidCardDuringSignUp] =
        useState("");

    // Wallet Settings
    const [isSEPAAllowed, setisSEPAAllowed] = useState('')
    const [myIbanAllowed, setmyIbanAllowed] = useState('')
    const [loadMoneyAllowed, setLoadMoneyAllowed] = useState("");
    const [withdrawMoneyAllowed, setWithdrawMoneyAllowed] = useState("");
    const [sendMoneyAllowed, setsendMoneyAllowed] = useState("");
    const [requestMoneyAllowed, setRequestMoneyAllowed] = useState("");

    const [activityLogAllowed, setactivityLogAllowed] = useState("");
    const [walletAllowed, setWalletAllowed] = useState("");
    const [payAllowed, setpayAllowed] = useState("");
    const [payOption, setpayOption] = useState("");

    const [walletTransferAllowed, setwalletTransferAllowed] = useState("");
    const [cashoutAllowed, setcashoutAllowed] = useState("");
    const [checkDepositAllowed, setcheckDepositAllowed] = useState("");
    const [payOrderAllowed, setPayOrderAllowed] = useState("");

    const [payReceivedAllowed, setpayReceivedAllowed] = useState("");
    const [cashInAllowed, setcashInAllowed] = useState("");
    const [requestCashInAllowed, setrequestCashInAllowed] = useState("");
    const [requestCashOutAllowed, setrequestCashOutAllowed] = useState("");

    const [withdrawVerificationAllowed, setwithdrawVerificationAllowed] =
        useState("");
    const [sendMoneyMerchantRequired, setsendMoneyMerchantRequired] =
        useState("");
    const [radioAllowed, setradioAllowed] = useState("");
    const [blockChainAllowed, setblockChainAllowed] = useState("");
    const [rechargeAllowed, setrechargeAllowed] = useState("");

    const [myCardAllowed, setyCardAllowed] = useState("");
    const [myBankAllowed, setmyBankAllowed] = useState("");
    const [loyaltyPointsAllowed, setloyaltyPointsAllowed] = useState("");
    const [transactionHistoryAllowed, settransactionHistoryAllowed] =
        useState("");
    const [walletHistoryAllowed, setwalletHistoryAllowed] = useState("");
    const [profileSettingsAllowed, setprofileSettingsAllowed] = useState("");
    const [billPaymentAllowed, setbillPaymentAllowed] = useState("");
    const [donationAllowed, setdonationAllowed] = useState("");
    const [loadwithWalletAllowed, setloadwithWalletAllowed] = useState("");
    const [integration, setintegration] = useState("");
    const [sendSecurityAllowed, setendSecurityAllowed] = useState("");
    const [loadSecurityAllowed, setloadSecurityAllowed] = useState("");
    const [requestSecurityAllowed, setrequestSecurityAllowed] = useState("");
    const [withdrawSecurityAllowed, setwithdrawSecurityAllowed] = useState("");
    const [paySecurityAllowed, setpaySecurityAllowed] = useState("");
    const [cashoutSecurityAllowed, setcashoutSecurityAllowed] = useState("");
    const [payOrderSecurityAllowed, setpayOrderSecurityAllowed] = useState("");
    const [purchaseSecurityAllowed, setpurchaseSecurityAllowed] = useState("");
    const [cashinSecurityAllowed, setcashinSecurityAllowed] = useState("");
    const [userManagement, setuserManagement] = useState("");
    const [storeRequired, setstoreRequired] = useState("");

    const [voucherPurchaseAllowed, setvoucherPurchaseAllowed] = useState("");

    const [transactionHistoryAllowedv, settransactionHistoryAllowedv] =
        useState("");
    const [myVoucherAllowed, setmyVoucherAllowed] = useState("");
    const [redeemPasswordAllowed, setredeemPasswordAllowed] = useState("");

    const [redeemAuthentication, setredeemAuthentication] = useState("");
    const [redeemExactOrderAmount, setredeemExactOrderAmount] = useState("");
    const [settlementReportRequired, setsettlementReportRequired] = useState("");
    const [aPIKeyRequired, setaPIKeyRequired] = useState("");

    const [updateConfigurationStatus, setUpdateConfigurationStatus] =
        useState(false);
    const [updateConfigurationArray, setUpdateConfigurationArray] = useState("");

    const [notificationOpen, setNotificationOpen] = useState(false);

    const [sendToContactAllowed, setsendToContactAllowed] = useState('');
    const [sendToSelfAllowed, setsendToSelfAllowed] = useState('');
    const [sendToOtherAllowed, setsendToOtherAllowed] = useState('');
    const [checkBalanceAllowed, setcheckBalanceAllowed] = useState('');
    const [manageBeneficiariesAllowed, setmanageBeneficiariesAllowed] = useState('');


    //Refund configuration
    const [getRefund, setGetRefund] = useState('');
    const [getFullRefund, setGetFullRefund] = useState('');
    const [getPartialRefund, setGetPartialRefund] = useState('')

    //Transaction configuration
    const [getIsTermsAndConditions, setGetIsTermsAndConditions] = useState('');
    // const [getTermsURL, setGetTermsURL] = useState("");
    const [getRedirectTime, setGetRedirectTime] = useState("");
    const [getIsAutoRedirect, setGetIsAutoRedirect] = useState("Y");
    const [countrySelection, setcountrySelection] = useState('N');
    //Two Factor Authentication

    const [twofaSmsOtpAllowed, settwofaSmsOtpAllowed] = useState('');
    const [twofaEmailOtpAllowed, settwofaEmailOtpAllowed] = useState('');
    const [twofaConfigurationUser, settwofaConfigurationUser] = useState('');
    const [twofaconfigurationGoogle, settwofaconfigurationGoogle] = useState('');


    //Consent (Transaction and Sign Up)
    const [getSignUpConsent, setGetSignUpConsent] = useState('');
    const [getTransactionConsent, setGetTransactionConsent] = useState('')

    const getWalletRolesRes = useSelector(
        ({ walletAcRequired }) => walletAcRequired
    );


    const getConfigurationViewListApiFun = () => {
        setIsLoading(true);
        setGetConfigViewStatus(true);
        const getViewCongigurationListsReq = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: WalletOwnwerFromSearch || "",
                role: role == "Select Role" ? "" : role
            }
        };
        return dispatch(
            getViewConfigurationAdminList(getViewCongigurationListsReq, authToken)
        );
    };

    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            getConfigurationViewListApiFun();
        }
    }, [regenerateTokenRes.data.AuthToken]);

    const getViewCongigurationListRes = useSelector(
        ({ getViewConfigurationAdminLists }) => getViewConfigurationAdminLists
    );

    const updateConfigurationListRes = useSelector(
        ({ getUpdateConfigurationAdminList }) => getUpdateConfigurationAdminList
    );



    useEffect(() => {
        dispatch(resetGetViewConfigurationAdmin());
    }, []);

    useEffect(() => {
        if (getConfigViewStatus) {
            if (getViewCongigurationListRes.success) {
                setIsLoading(false);
                setGetConfigViewRes(getViewCongigurationListRes.data);
                setDealRequired(
                    getViewCongigurationListRes.data.marketPlaceConfRqeVO
                        ? getViewCongigurationListRes.data.marketPlaceConfRqeVO.isDealsWant
                        : ""
                );
                setOrderMgtAllowed(
                    getViewCongigurationListRes.data.marketPlaceConfRqeVO
                        ? getViewCongigurationListRes.data.marketPlaceConfRqeVO
                            .orderSellRptAllowed
                        : ""
                );
                setPrdMgtAllowed(
                    getViewCongigurationListRes.data.marketPlaceConfRqeVO
                        ? getViewCongigurationListRes.data.marketPlaceConfRqeVO
                            .productMngtAllowed
                        : ""
                );
                setorderSellReportAllowed(
                    getViewCongigurationListRes.data.marketPlaceConfRqeVO
                        ? getViewCongigurationListRes.data.marketPlaceConfRqeVO
                            .orderSellRptAllowed
                        : ""
                );
                setIsPromoCodeAllowed(
                    getViewCongigurationListRes.data.marketPlaceConfRqeVO
                        ? getViewCongigurationListRes.data.marketPlaceConfRqeVO
                            .isPromoCodeAllowed
                        : ""
                );
                //isPromoCodeAllowed

                setMerchantRequired(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO.isMerchant
                        : ""
                );
                setchangePasswordAllowed(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO
                            .changePasswordAllowed
                        : ""
                );
                setDealerMappingRequired(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO
                            .dealerMAppingAllowed
                        : ""
                );
                setPrefixAccountId(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO.prefixAccountId
                        : ""
                );

                setEmailAllowed(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO.isEmailAllowed
                        : ""
                );
                setSmsAllowed(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO.isSMSAllowed
                        : ""
                );
                setBusinessSignupAllowed(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO
                            .businessSignupAllowed
                        : ""
                );
                setmaxUboCount(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO.uboCount
                        : ""
                );

                setmaxDirectorCount(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO.directorCount
                        : ""
                );
                setSmsAllowed(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO.isSMSAllowed
                        : ""
                );
                setautoFilledAllowed(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO.isAutoFilled
                        : ""
                );
                setmaxUboCount(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO.uboCount
                        : ""
                );

                setaddBankDuringSignUp(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO
                            .isSignUpBankRequired
                        : ""
                );
                setdateOfBirthRequired(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO.ifDOBrequired
                        : ""
                );
                setaddBankDuringSignUp(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO
                            .isSignUpBankRequired
                        : ""
                );
                setdateOfBirthRequired(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO.ifDOBrequired
                        : ""
                );
                setnationalityRequired(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO
                            .ifNationalityRequired
                        : ""
                );
                setKycRequired(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO.isKycRequired
                        : ""
                );
                setNewDeviceCheckAllowed(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO.isNewDevice
                        : ''
                )

                setisCustCreation(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO.isCustCreationAllowed
                        : ''
                )
                settwofaconfigurationGoogle(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO.twoFactorGoogle
                        : ''
                )


                //Sign Up and Login  End

                //Prepaid Card start

                setCustomerActivateCardRequired(
                    getViewCongigurationListRes.data.preparedCardRqeVO
                        ? getViewCongigurationListRes.data.preparedCardRqeVO
                            .allowCustomerToActivateCard
                        : ""
                );
                setprepaidCardFeatureRequired(
                    getViewCongigurationListRes.data.preparedCardRqeVO
                        ? getViewCongigurationListRes.data.preparedCardRqeVO
                            .isPrepaidCardFeatureRequired
                        : ""
                );

                setapplyingPrepaidCardDuringSignUp(
                    getViewCongigurationListRes.data.preparedCardRqeVO
                        ? getViewCongigurationListRes.data.preparedCardRqeVO.prepaidCard
                        : ""
                );

                //Prepaid Card end

                // Wallet Settings  start

                setmyIbanAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO ?
                        getViewCongigurationListRes.data.walletConfReqVO.isMyIBANAllowed : ''
                )
                setLoadMoneyAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO
                            .isLoadMoneyAllowed
                        : ""
                );
                setWithdrawMoneyAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO
                            .isWithdrawMoneyAllowed
                        : ""
                );
                setsendMoneyAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO
                            .isSendMoneyAllowed
                        : ""
                );
                setRequestMoneyAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO
                            .isRequestMoneyAllowed
                        : ""
                );

                setactivityLogAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO
                            .isActivityLogAllowed
                        : ""
                );
                setWalletAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isMyWalletAllowed
                        : ""
                );
                setpayAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isPayAllowed
                        : ""
                );

                setrequestSecurityAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.requestPinAllowed
                        : ""
                );

                setloadSecurityAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.loadPinAllowed
                        : ""
                );

                setendSecurityAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.sendPinAllowed
                        : ""
                );

                setpayOption(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.payOption
                        : ""
                );

                setwalletTransferAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO
                            .isWalletTransferAllowed
                        : ""
                );
                setcashoutAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isCashOutAllowed
                        : ""
                );
                setcheckDepositAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isCheckDeposite
                        : ""
                );

                setpayReceivedAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isPayAllowed
                        : ""
                );
                setcashInAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isCashinAllowed
                        : ""
                );
                setrequestCashInAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO
                            .isRequestCashinAllowed
                        : ""
                );
                setrequestCashOutAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO
                            .isRequestCashOutAllowed
                        : ""
                );
                setwithdrawVerificationAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO
                            .isWithdrawalVerification
                        : ""
                );

                setsendMoneyMerchantRequired(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO
                            .isSendMoneyMerchant
                        : ""
                );

                setradioAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isRadioAllowed
                        : ""
                );

                setblockChainAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO
                            .isBlockchainAllowed
                        : ""
                );

                setrechargeAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isRechargeAllowed
                        : ""
                );

                setyCardAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isMyCardAllowed
                        : ""
                );

                setmyBankAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isMyBankAllowed
                        : ""
                );

                setloyaltyPointsAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO
                            .isLoyaltyPointsAllowed
                        : ""
                );

                settransactionHistoryAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO
                            .transactionHistAllowed
                        : ""
                );

                setwalletHistoryAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.walletHistAllowed
                        : ""
                );

                setprofileSettingsAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO
                            .profileSettingAllowed
                        : ""
                );

                setisSEPAAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO
                            .isSEPAAllowed
                        : ""
                );

                setbillPaymentAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isBillPayment
                        : ""
                );

                setdonationAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isDonation
                        : ""
                );

                setdonationAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isDonation
                        : ""
                );
                setloadwithWalletAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO
                            .isLoadWithWalletAllowed
                        : ""
                );
                setintegration(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.integrationType
                        : ""
                );

                setwithdrawSecurityAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO
                            .withdrawPinAllowed
                        : ""
                );
                setpaySecurityAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.payPinAllowed
                        : ""
                );
                setcashoutSecurityAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.cashoutPinAllowed
                        : ""
                );
                setpayOrderSecurityAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO
                            .payOrderPinAllowed
                        : ""
                );
                setpurchaseSecurityAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO
                            .purchasePinAllowed
                        : ""
                );
                setcashinSecurityAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO
                            .isCashinSecurityAllowed
                        : ""
                );
                setuserManagement(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isUserManagement
                        : ""
                );
                setstoreRequired(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isStoreRequired
                        : ""
                );

                setPayOrderAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isPayOrder
                        : ""
                );

                //Voucher configuration
                setvoucherPurchaseAllowed(
                    getViewCongigurationListRes.data.voucherConfigurationVO
                        ? getViewCongigurationListRes.data.voucherConfigurationVO
                            .voucherPurchaseAllowed
                        : ""
                );

                settransactionHistoryAllowedv(
                    getViewCongigurationListRes.data.voucherConfigurationVO
                        ? getViewCongigurationListRes.data.voucherConfigurationVO
                            .voucherTransactionHistoryAllowed
                        : ""
                );

                setmyVoucherAllowed(
                    getViewCongigurationListRes.data.voucherConfigurationVO
                        ? getViewCongigurationListRes.data.voucherConfigurationVO
                            .myVouchersAllowed
                        : ""
                );

                setmyVoucherAllowed(
                    getViewCongigurationListRes.data.voucherConfigurationVO
                        ? getViewCongigurationListRes.data.voucherConfigurationVO
                            .myVouchersAllowed
                        : ""
                );

                setredeemPasswordAllowed(
                    getViewCongigurationListRes.data.voucherConfigurationVO
                        ? getViewCongigurationListRes.data.voucherConfigurationVO
                            .voucherTransPasswordAllowed
                        : ""
                );

                setredeemAuthentication(
                    getViewCongigurationListRes.data.voucherConfigurationVO
                        ? getViewCongigurationListRes.data.voucherConfigurationVO
                            .redeemConfiguration
                        : ""
                );

                setredeemExactOrderAmount(
                    getViewCongigurationListRes.data.voucherConfigurationVO
                        ? getViewCongigurationListRes.data.voucherConfigurationVO
                            .isRedeemExactOrderAmount
                        : ""
                );

                setsettlementReportRequired(
                    getViewCongigurationListRes.data.voucherConfigurationVO
                        ? getViewCongigurationListRes.data.voucherConfigurationVO
                            .isSettelementRequired
                        : ""
                );
                setaPIKeyRequired(
                    getViewCongigurationListRes.data.voucherConfigurationVO
                        ? getViewCongigurationListRes.data.voucherConfigurationVO.isapikey
                        : ""
                );
                setsendToContactAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isSendToContactAllowed
                        : ''
                );
                setsendToSelfAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isSendToSelfAllowed
                        : ''
                );
                setsendToOtherAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isSendToSelfAllowed
                        : ''
                );
                setcheckBalanceAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isCheckBalanceAllowed
                        : ''
                );
                setmanageBeneficiariesAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isManageBeneficiariesAllowed
                        : ''
                );
                setGetRefund(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isRefund
                        : ''
                );
                setGetFullRefund(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isFullRefund
                        : ''
                );
                setGetPartialRefund(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isPartialRefund
                        : ''
                );
                setGetIsTermsAndConditions(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isTermsAndConditions
                        : ''
                );
                 setcountrySelection(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isCountrySelection
                        : ''
                );
                // setGetTermsURL(
                //     getViewCongigurationListRes.data.walletConfReqVO
                //         ? getViewCongigurationListRes.data.walletConfReqVO.termsUrl
                //         : ''
                // );
                settwofaSmsOtpAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.twoFactorSMS
                        : ''
                );
                settwofaEmailOtpAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.twoFactorEmail
                        : ''
                );
                settwofaConfigurationUser(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.twoFactorByUser
                        : ''
                );
                setGetSignUpConsent(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.signupConsent
                        : ''
                );
                setGetTransactionConsent(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.transactionConsent
                        : ''
                );
                setGetRedirectTime(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.redirectTime
                        : ''
                );
                setGetIsAutoRedirect(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isAutoRedirect
                        : ''
                );
            }
        }
    }, [getViewCongigurationListRes.success]);

    const handleChange = ({ target: { name, value } }) => {
        if (name === "walletRole") {
            setWalletRole(value);
        }
        if (name === "dealRequired") {
            setDealRequired(value);
        }
        if (name === "orderMgtAllowed") {
            setOrderMgtAllowed(value);
        }
        if (name === "prdMgtAllowed") {
            setPrdMgtAllowed(value);
        }

        if (name === "orderSellReportAllowed") {
            setorderSellReportAllowed(value);
        }

        if (name === "isPromoCodeAllowed") {
            setIsPromoCodeAllowed(value);
        }

        //Sign Up and Login Start

        if (name === "merchantRequired") {
            setMerchantRequired(value);
        }

        if (name === "newDeviceCheckAllowed") {
            setNewDeviceCheckAllowed(value);
        }

        if (name === "changePasswordAllowed") {
            setchangePasswordAllowed(value);
        }

        if (name === "dealerMappingRequired") {
            setDealerMappingRequired(value);
        }

        if (name === "prefixAccountId") {
            setPrefixAccountId(value);
        }

        if (name === "customerCreationAllowed") {
            setCustomerCreationAllowed(value);
        }

        if (name === "emailAllowed") {
            setEmailAllowed(value);
        }

        if (name === "smsAllowed") {
            setSmsAllowed(value);
        }

        if (name === "businessSignupAllowed") {
            setBusinessSignupAllowed(value);
        }

        if (name === "maxUboCount") {
            setmaxUboCount(value);
        }

        if (name === "maxDirectorCount") {
            setmaxDirectorCount(value);
        }

        if (name === "autoFilledAllowed") {
            setautoFilledAllowed(value);
        }

        if (name === "addBankDuringSignUp") {
            setaddBankDuringSignUp(value);
        }

        if (name === "dateOfBirthRequired") {
            setdateOfBirthRequired(value);
        }

        if (name === "nationalityRequired") {
            setnationalityRequired(value);
        }
        if (name === "KYCRequired") {
            setKycRequired(value);
        }

        if (name === 'isCustCreationAllowed') {
            setisCustCreation(value);
        }

        //Prepaid Card

        if (name === "customerActivateCardRequired") {
            setCustomerActivateCardRequired(value);
        }

        if (name === "prepaidCardFeatureRequired") {
            setprepaidCardFeatureRequired(value);
        }

        if (name === "applyingPrepaidCardDuringSignUp") {
            setapplyingPrepaidCardDuringSignUp(value);
        }

        //Wallet Settings

        if (name === 'isSEPAAllowed') {
            setisSEPAAllowed(value);
        }

        if (name === 'myIbanAllowed') {
            setmyIbanAllowed(value)
        }

        if (name === "loadMoneyAllowed") {
            setLoadMoneyAllowed(value);
        }

        if (name === "withdrawMoneyAllowed") {
            setWithdrawMoneyAllowed(value);
        }

        if (name === "sendMoneyAllowed") {
            setsendMoneyAllowed(value);
        }

        if (name === "requestMoneyAllowed") {
            setRequestMoneyAllowed(value);
        }

        if (name === "activityLogAllowed") {
            setactivityLogAllowed(value);
        }

        if (name === "walletAllowed") {
            setWalletAllowed(value);
        }

        if (name === "payAllowed") {
            setpayAllowed(value);
        }

        if (name === "payOption") {
            setpayOption(value);
        }

        if (name === "walletTransferAllowed") {
            setwalletTransferAllowed(value);
        }

        if (name === "cashoutAllowed") {
            setcashoutAllowed(value);
        }

        if (name === "checkDepositAllowed") {
            setcheckDepositAllowed(value);
        }

        if (name === "payOrderAllowed") {
            setPayOrderAllowed(value);
        }

        if (name === "payReceivedAllowed") {
            setpayReceivedAllowed(value);
        }

        if (name === "cashInAllowed") {
            setcashInAllowed(value);
        }

        if (name === "requestCashInAllowed") {
            setrequestCashInAllowed(value);
        }

        if (name === "requestCashOutAllowed") {
            setrequestCashOutAllowed(value);
        }

        if (name === "withdrawVerificationAllowed") {
            setwithdrawVerificationAllowed(value);
        }

        if (name === "sendMoneyMerchantRequired") {
            setsendMoneyMerchantRequired(value);
        }

        if (name === "radioAllowed") {
            setradioAllowed(value);
        }

        if (name === "blockChainAllowed") {
            setblockChainAllowed(value);
        }
        if (name === "rechargeAllowed") {
            setrechargeAllowed(value);
        }

        if (name === "myCardAllowed") {
            setyCardAllowed(value);
        }

        if (name === "myBankAllowed") {
            setmyBankAllowed(value);
        }

        if (name === "loyaltyPointsAllowed") {
            setloyaltyPointsAllowed(value);
        }

        if (name === "transactionHistoryAllowed") {
            settransactionHistoryAllowed(value);
        }

        if (name === "walletHistoryAllowed") {
            setwalletHistoryAllowed(value);
        }

        if (name === "profileSettingsAllowed") {
            setprofileSettingsAllowed(value);
        }

        if (name === "billPaymentAllowed") {
            setbillPaymentAllowed(value);
        }

        if (name === "donationAllowed") {
            setdonationAllowed(value);
        }

        if (name === "loadwithWalletAllowed") {
            setloadwithWalletAllowed(value);
        }

        if (name === "integration") {
            setintegration(value);
        }

        if (name === "sendSecurityAllowed") {
            setendSecurityAllowed(value);
        }

        if (name === "loadSecurityAllowed") {
            setloadSecurityAllowed(value);
        }

        if (name === "requestSecurityAllowed") {
            setrequestSecurityAllowed(value);
        }

        if (name === "withdrawSecurityAllowed") {
            setwithdrawSecurityAllowed(value);
        }

        if (name === "paySecurityAllowed") {
            setpaySecurityAllowed(value);
        }

        if (name === "cashoutSecurityAllowed") {
            setcashoutSecurityAllowed(value);
        }

        if (name === "payOrderSecurityAllowed") {
            setpayOrderSecurityAllowed(value);
        }

        if (name === "purchaseSecurityAllowed") {
            setpurchaseSecurityAllowed(value);
        }

        if (name === "cashinSecurityAllowed") {
            setcashinSecurityAllowed(value);
        }

        if (name === "userManagement") {
            setuserManagement(value);
        }

        if (name === "storeRequired") {
            setstoreRequired(value);
        }

        // Voucher Configuration
        if (name === "voucherPurchaseAllowed") {
            setvoucherPurchaseAllowed(value);
        }

        if (name === "transactionHistoryAllowedv") {
            settransactionHistoryAllowedv(value);
        }

        if (name === "myVoucherAllowed") {
            setmyVoucherAllowed(value);
        }

        if (name === "redeemPasswordAllowed") {
            setredeemPasswordAllowed(value);
        }

        if (name === "redeemAuthentication") {
            setredeemAuthentication(value);
        }

        if (name === "redeemExactOrderAmount") {
            setredeemExactOrderAmount(value);
        }
        if (name === "settlementReportRequired") {
            setsettlementReportRequired(value);
        }

        if (name === "aPIKeyRequired") {
            setaPIKeyRequired(value);
        }

        //Bank Configuration
        if (name === 'sendToContactAllowed') {
            setsendToContactAllowed(value);
        }
        if (name === 'sendToSelfAllowed') {
            setsendToSelfAllowed(value);
        }
        if (name === 'sendToOtherAllowed') {
            setsendToOtherAllowed(value);
        }
        if (name === 'checkBalanceAllowed') {
            setcheckBalanceAllowed(value);
        }
        if (name === 'manageBeneficiariesAllowed') {
            setmanageBeneficiariesAllowed(value);
        }

        //Refund configuration
        if (name === 'getRefund') {
            setGetRefund(value);
        }
        if (name === 'getPartialRefund') {
            setGetPartialRefund(value);
        }
        if (name === 'getFullRefund') {
            setGetFullRefund(value);
        }

        //Transaction configuration
        if (name === "getIsTermsAndConditions") {
            setGetIsTermsAndConditions(value);
        }
        // if (name === "getTermsURL") {
        //     setGetTermsURL(value);
        // }
        if (name === "getRedirectTime") {
            setGetRedirectTime(value);
        }
        if (name === "getIsAutoRedirect") {
            setGetIsAutoRedirect(value);
        }
        if(name==="countrySelection"){
			setcountrySelection(value)
		}

        //Two factor authentication
        if (name === 'twofaSmsOtpAllowed') {
            settwofaSmsOtpAllowed(value);
        }
        if (name === 'twofaEmailOtpAllowed') {
            settwofaEmailOtpAllowed(value);
        }
        if (name === 'twofaConfigurationUser') {
            settwofaConfigurationUser(value);
        }
        if (name === 'twofaconfigurationGoogle') {
            settwofaconfigurationGoogle(value);
        }

        //Consent (Sign up and Transaction)
        if (name === 'getSignUpConsent') {
            setGetSignUpConsent(value);
        }
        if (name === 'getTransactionConsent') {
            setGetTransactionConsent(value);
        }

    };


    const editConfigurationListApi = () => {
        setUpdateConfigurationStatus(true);
        const editConfigurationListApiReqs = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: WalletOwnwerFromSearch,
                role: walletRole
            },
            settingsRequestVO: {
                action: "update"
            },
            accountConfReqVO: {
                businessSignupAllowed: businessSignupAllowed,
                changePasswordAllowed: changePasswordAllowed,
                dealerMAppingAllowed: dealerMappingRequired,
                directorCount: maxUboCount,
                isAutoFilled: autoFilledAllowed == "Y" ? "1" : "0",
                isCustCreationAllowed: isCustCreation,
                isEmailAllowed: emailAllowed == "Y" ? "1" : "0",
                isMerchant: merchantRequired,
                isSMSAllowed: smsAllowed == "Y" ? "1" : "0",
                prefixAccountId: prefixAccountId,
                uboCount: maxUboCount,
                ifDOBrequired: dateOfBirthRequired,
                ifNationalityRequired: nationalityRequired,
                isNewDevice: newDeviceCheckAllowed,
                isSignUpBankRequired: addBankDuringSignUp,
                isKycRequired: KycRequired,
                twoFactorGoogle: twofaconfigurationGoogle
            },
            marketPlaceConfReqVO: {
                walletOwnerId: WalletOwnwerFromSearch,
                role: walletRole,
                isDealsWant: dealRequired,
                isPromoCodeAllowed: isPromoCodeAllowed,
                orderMngtAllowed: orderMgtAllowed,
                orderSellRptAllowed: orderSellReportAllowed,
                productMngtAllowed: prdMgtAllowed
            },
            voucherConfigurationVO: {
                isRedeemExactOrderAmount: redeemExactOrderAmount,
                isSettelementRequired: settlementReportRequired,
                isapikey: aPIKeyRequired,
                myVouchersAllowed: myVoucherAllowed,
                redeemConfiguration: "customerEmail",
                settingId: "2",
                voucherChangePasswordAllowed: "N",
                voucherPurchaseAllowed: voucherPurchaseAllowed,
                voucherTransPasswordAllowed: redeemPasswordAllowed,
                voucherTransactionHistoryAllowed: transactionHistoryAllowedv
            },
            walletConfReqVO: {
                cashoutPinAllowed: cashoutSecurityAllowed,
                integrationType: integration,
                isActivityLogAllowed: activityLogAllowed,
                isBillPayment: billPaymentAllowed,
                isBlockchainAllowed: blockChainAllowed,
                isCashOutAllowed: cashoutAllowed,
                isCashinAllowed: cashInAllowed,
                isCashinSecurityAllowed: requestCashInAllowed,
                isCheckDeposite: checkDepositAllowed,
                isDonation: donationAllowed,
                isLoadAmountPageAllowed: "Y",
                isLoadMoneyAllowed: loadMoneyAllowed,
                isLoadWithWalletAllowed: loadwithWalletAllowed,
                isLoyaltyPointsAllowed: loyaltyPointsAllowed,
                isMyBankAllowed: myBankAllowed,
                isMyCardAllowed: myCardAllowed,
                isMyWalletAllowed: walletAllowed,
                isPayAllowed: payAllowed,
                isPayReceived: payReceivedAllowed,
                isRadioAllowed: radioAllowed,
                isRechargeAllowed: rechargeAllowed,
                isRequestCashOutAllowed: requestCashOutAllowed,
                isRequestCashinAllowed: requestCashInAllowed,
                isRequestMoneyAllowed: requestMoneyAllowed,
                isSendMoneyAllowed: sendMoneyAllowed,
                isSendMoneyMerchant: sendMoneyMerchantRequired,
                isStoreRequired: storeRequired,
                isUserManagement: userManagement,
                isWalletTransferAllowed: walletTransferAllowed,
                isWithdrawMoneyAllowed: withdrawMoneyAllowed,
                isWithdrawalVerification: withdrawVerificationAllowed,
                loadPinAllowed: loadSecurityAllowed,
                payOption: payOption,
                payOrderPinAllowed: payOrderSecurityAllowed,
                payPinAllowed: paySecurityAllowed,
                profileSettingAllowed: profileSettingsAllowed,
                purchasePinAllowed: purchaseSecurityAllowed,
                requestPinAllowed: requestSecurityAllowed,
                role: walletRole,
                sendPinAllowed: sendSecurityAllowed,
                transactionHistAllowed: transactionHistoryAllowed,
                walletHistAllowed: walletHistoryAllowed,
                withdrawPinAllowed: withdrawSecurityAllowed,
                isPayOrder: payOrderAllowed,
                isSendToContactAllowed: sendToContactAllowed,
                isSendToSelfAllowed: sendToSelfAllowed,
                isSendToOtherAllowed: sendToOtherAllowed,
                isCheckBalanceAllowed: checkBalanceAllowed,
                isManageBeneficiariesAllowed: manageBeneficiariesAllowed,
                isMyIBANAllowed: myIbanAllowed,
                isSEPAAllowed: isSEPAAllowed,
                isRefund: getRefund,
                isPartialRefund: getPartialRefund,
                isFullRefund: getFullRefund,
                isTermsAndConditions: getIsTermsAndConditions,
                // termsUrl: getTermsURL,
                twoFactorSMS: twofaSmsOtpAllowed,
                twoFactorEmail: twofaEmailOtpAllowed,
                twoFactorByUser: twofaConfigurationUser,
                signupConsent: getSignUpConsent,
                transactionConsent: getTransactionConsent,
                isAutoRedirect: getIsAutoRedirect,
                redirectTime: getRedirectTime,
                isCountrySelection:countrySelection
            },
            preparedCardRqeVO: {
                allowCustomerToActivateCard: customerActivateCardRequired,
                isPrepaidCardFeatureRequired: prepaidCardFeatureRequired,
                prepaidCard: applyingPrepaidCardDuringSignUp
            }
        };
        dispatch(getUpdateConfigurationAdminList(editConfigurationListApiReqs, authToken));
    };


    const updateConfigurationFunc = () => {
        if (updateConfigurationStatus) {
            if (updateConfigurationListRes.data.status == "success") {
                setUpdateConfigurationArray(updateConfigurationListRes.data);
                setNotificationOpen(true);
                getConfigurationViewListApiFun();
            }
            if (updateConfigurationListRes.data.status == "failed") {
                setUpdateConfigurationArray(updateConfigurationListRes.data);
                setNotificationOpen(true);
                if (
                    updateConfigurationListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    updateConfigurationListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    };



    useEffect(() => {
        if (updateConfigurationListRes.data.status) {
            updateConfigurationFunc();
        }
    }, [updateConfigurationListRes]);

    const handleNoticationClose = () => {
        setNotificationOpen(false);
    };

    return (
        <>
            <Layout>
                <BackButton />
                {isLoading ? (
                    <LoadingSpinner />
                ) : (
                    <Card>
                        <Grid
                            container
                            spacing={2}
                            style={{ padding: "25px", marginTop: "2rem" }}
                        >
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    // select
                                    // autoFocus
                                    margin="dense"
                                    id="name"
                                    label="Wallet Owner Id"
                                    fullWidth
                                    variant="standard"
                                    type="text"
                                    disabled
                                    name="OwnerId"
                                    // value={WalletOwnwerFromSearch} 
                                    defaultValue={WalletOwnwerFromSearch}
                                >
                                    <MenuItem value="WalletOwnwerFromSearch">
                                        {WalletOwnwerFromSearch}
                                    </MenuItem>

                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    // select
                                    // autoFocus
                                    margin="dense"
                                    id="name"
                                    label="Role"
                                    fullWidth
                                    variant="standard"
                                    disabled
                                    type="text"
                                    name="role"
                                    defaultValue={role}

                                // onChange={handleChange}
                                >
                                    <MenuItem value="Select Role" selected="Select Role">
                                        Select Role
                                    </MenuItem>

                                    {getWalletRolesRes.data.rolesList &&
                                        getWalletRolesRes.data.rolesList &&
                                        []
                                            .concat(getWalletRolesRes.data.rolesList)
                                            .map((dropdown) => (
                                                <MenuItem value={dropdown}>{dropdown}</MenuItem>
                                            ))}
                                </TextField>
                            </Grid>
                        </Grid>

                        <Grid container spacing={2} style={{ padding: "25px" }}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="text-center themeBackground"
                                    variant="secondary"
                                    fullWidth={true}
                                >
                                    <Typography variant="body1"> Market Place </Typography>
                                </Alert>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    label="Deals Required"
                                    fullWidth
                                    name="dealRequired"
                                    variant="standard"
                                    type="text"
                                    value={dealRequired || ""}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y (Allow)</MenuItem>
                                    <MenuItem value="N">N (Not Allow)</MenuItem>
                                    <MenuItem value="D">D (Display and Allow)</MenuItem>

                                    {/* <MenuItem value={dealRequired} selected={dealRequired}>
                  {dealRequired}
                </MenuItem> */}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    label="Order Management Allowed"
                                    fullWidth
                                    variant="standard"
                                    type="text"
                                    name="orderMgtAllowed"
                                    value={orderMgtAllowed}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y (Allow)</MenuItem>
                                    <MenuItem value="N">N (Not Allow)</MenuItem>
                                    <MenuItem value="D">D (Display and Allow)</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // required
                                    // autoFocus
                                    margin="dense"
                                    id="name"
                                    label="
                Product Management Allowed"
                                    fullWidth
                                    variant="standard"
                                    type="text"
                                    name="prdMgtAllowed"
                                    value={prdMgtAllowed}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y (Allow)</MenuItem>
                                    <MenuItem value="N">N (Not Allow)</MenuItem>
                                    <MenuItem value="D">D (Display and Allow)</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // required
                                    // autoFocus
                                    margin="dense"
                                    label="Order Sell Report Allowed"
                                    fullWidth
                                    variant="standard"
                                    type="text"
                                    name="orderSellReportAllowed"
                                    value={orderSellReportAllowed}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y (Allow)</MenuItem>
                                    <MenuItem value="N">N (Not Allow)</MenuItem>
                                    <MenuItem value="D">D (Display and Allow)</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // required
                                    // autoFocus
                                    margin="dense"
                                    id="name"
                                    label="Promo Code Allowed"
                                    fullWidth
                                    variant="standard"
                                    type="text"
                                    name="isPromoCodeAllowed"
                                    value={isPromoCodeAllowed}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y (Allow)</MenuItem>
                                    <MenuItem value="N">N (Not Allow)</MenuItem>
                                    <MenuItem value="D">D (Display and Allow)</MenuItem>
                                </TextField>
                            </Grid>
                        </Grid>

                        <Grid container spacing={2} style={{ padding: "25px" }}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="text-center themeBackground"
                                    variant="secondary"
                                    fullWidth={true}
                                >
                                    <Typography variant="body1"> Sign Up</Typography>
                                </Alert>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // required
                                    // autoFocus
                                    margin="dense"
                                    label="Merchant Required"
                                    fullWidth
                                    variant="standard"
                                    type="text"
                                    name="merchantRequired"
                                    value={merchantRequired || ""}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y (Allow)</MenuItem>
                                    <MenuItem value="N">N (Not Allow)</MenuItem>
                                    <MenuItem value="D">D (Display and Allow)</MenuItem>
                                </TextField>
                            </Grid>


                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    label="Dealer Mapping Required"
                                    fullWidth
                                    variant="standard"
                                    type="text"
                                    name="dealerMappingRequired"
                                    value={dealerMappingRequired || ""}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y (Allow)</MenuItem>
                                    <MenuItem value="N">N (Not Allow)</MenuItem>
                                    <MenuItem value="D">D (Display and Allow)</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    label="Prefix Account Id"
                                    fullWidth
                                    variant="standard"
                                    type="text"
                                    name="prefixAccountId"
                                    value={prefixAccountId || ""}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y (Allow)</MenuItem>
                                    <MenuItem value="N">N (Not Allow)</MenuItem>
                                    <MenuItem value="D">D (Display and Allow)</MenuItem>
                                </TextField>
                            </Grid>

                            {/* changes */}

                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // required
                                    // autoFocus
                                    margin="dense"
                                    label="Email Allowed"
                                    fullWidth
                                    variant="standard"
                                    type="text"
                                    name="emailAllowed"
                                    value={emailAllowed || ""}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="1">Y</MenuItem>
                                    <MenuItem value="0">N</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    label="SMS Allowed"
                                    fullWidth
                                    variant="standard"
                                    name="smsAllowed"
                                    value={smsAllowed || ""}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="1">Y</MenuItem>
                                    <MenuItem value="0">N</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    label="
                Business Signup Allowed"
                                    fullWidth
                                    variant="standard"
                                    type="text"
                                    name="businessSignupAllowed"
                                    value={businessSignupAllowed || ""}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="1">Y</MenuItem>
                                    <MenuItem value="0">N</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // required
                                    // autoFocus
                                    margin="dense"
                                    label="Max UBO Count"
                                    fullWidth
                                    variant="standard"
                                    type="text"
                                    name="maxUboCount"
                                    value={maxUboCount || ""}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="0">0</MenuItem>
                                    <MenuItem value="1">1</MenuItem>
                                    <MenuItem value="2">2</MenuItem>

                                    <MenuItem value="3">3</MenuItem>
                                    <MenuItem value="4">4</MenuItem>
                                    <MenuItem value="5">5</MenuItem>

                                    <MenuItem value="6">6</MenuItem>
                                    <MenuItem value="7">7</MenuItem>
                                    <MenuItem value="8">8</MenuItem>

                                    <MenuItem value="9">9</MenuItem>
                                    <MenuItem value="10">10</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    label="Max Director Count"
                                    fullWidth
                                    variant="standard"
                                    type="text"
                                    name="maxDirectorCount"
                                    value={maxDirectorCount || ""}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="0">0</MenuItem>
                                    <MenuItem value="1">1</MenuItem>
                                    <MenuItem value="2">2</MenuItem>

                                    <MenuItem value="3">3</MenuItem>
                                    <MenuItem value="4">4</MenuItem>
                                    <MenuItem value="5">5</MenuItem>

                                    <MenuItem value="6">6</MenuItem>
                                    <MenuItem value="7">7</MenuItem>
                                    <MenuItem value="8">8</MenuItem>

                                    <MenuItem value="9">9</MenuItem>
                                    <MenuItem value="10">10</MenuItem>
                                </TextField>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    label="AutoFilled Allowed"
                                    fullWidth
                                    variant="standard"
                                    type="text"
                                    name="autoFilledAllowed"
                                    value={autoFilledAllowed || ""}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="1">Y</MenuItem>
                                    <MenuItem value="0">N</MenuItem>
                                </TextField>
                            </Grid>



                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // required
                                    // autoFocus
                                    margin="dense"
                                    id="name"
                                    label="Add Bank During SignUp"
                                    fullWidth
                                    variant="standard"
                                    type="text"
                                    name="addBankDuringSignUp"
                                    value={addBankDuringSignUp || ""}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    label="Date Of Birth Required"
                                    fullWidth
                                    variant="standard"
                                    type="text"
                                    name="dateOfBirthRequired"
                                    value={dateOfBirthRequired || ""}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    label="Nationality Required"
                                    fullWidth
                                    variant="standard"
                                    type="text"
                                    name="nationalityRequired"
                                    value={nationalityRequired || ""}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    margin="dense"
                                    label="KYC Required"
                                    fullWidth
                                    variant="standard"
                                    type="text"
                                    name="KYCRequired"
                                    value={KycRequired || ""}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={8}>
                                <Box style={{ marginTop: "10px" }}>
                                    <Typography>Sign Up Consent</Typography>
                                    <textarea className="signup-consent" id="w3review" rows="5" style={{ minWidth: '66%' }}
                                        name="getSignUpConsent"
                                        value={getSignUpConsent || ""}
                                        onChange={handleChange}

                                    >
                                    </textarea>
                                </Box>

                            </Grid>
                        </Grid>

                        <Grid container spacing={2} style={{ padding: "25px" }}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="text-center themeBackground"
                                    variant="secondary"
                                    fullWidth={true}
                                >
                                    <Typography variant="body1">Two Factor Authentication </Typography>
                                </Alert>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    label="SMS OTP During Login Allowed"
                                    fullWidth
                                    variant="standard"
                                    type="text"
                                    name="twofaSmsOtpAllowed"
                                    value={twofaSmsOtpAllowed || ""}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y (Allow)</MenuItem>
                                    <MenuItem value="N">N (Not Allow)</MenuItem>
                                    {/* <MenuItem value="D">D (Display and Allow)</MenuItem> */}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    label="
								Email OTP During Login Allowed"
                                    fullWidth
                                    variant="standard"
                                    name="twofaEmailOtpAllowed"
                                    value={twofaEmailOtpAllowed || ""}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y (Allow)</MenuItem>
                                    <MenuItem value="N">N (Not Allow)</MenuItem>
                                    {/* <MenuItem value="D">D (Display and Allow)</MenuItem> */}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // required
                                    // autoFocus
                                    margin="dense"
                                    id="name"
                                    label="2FA Configuration By User"
                                    fullWidth
                                    variant="standard"
                                    type="text"
                                    name="twofaConfigurationUser"
                                    value={twofaConfigurationUser || ""}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // required
                                    // autoFocus
                                    margin="dense"
                                    id="name"
                                    label="2FA Google Authenticator"
                                    fullWidth
                                    variant="standard"
                                    type="text"
                                    name="twofaconfigurationGoogle"
                                    value={twofaconfigurationGoogle || ""}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>
                        </Grid>

                        <Grid container spacing={2} style={{ padding: "25px" }}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="text-center themeBackground"
                                    variant="secondary"
                                    fullWidth={true}
                                >
                                    <Typography variant="body1">Login</Typography>
                                </Alert>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    label="New Device Check Allowed"
                                    fullWidth
                                    variant="standard"
                                    type="text"
                                    name="newDeviceCheckAllowed"
                                    value={newDeviceCheckAllowed || ""}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y (Allow)</MenuItem>
                                    <MenuItem value="N">N (Not Allow)</MenuItem>
                                    <MenuItem value="D">D (Display and Allow)</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    label="
                Change Password Allowed"
                                    fullWidth
                                    variant="standard"
                                    name="changePasswordAllowed"
                                    value={changePasswordAllowed || ""}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y (Allow)</MenuItem>
                                    <MenuItem value="N">N (Not Allow)</MenuItem>
                                    <MenuItem value="D">D (Display and Allow)</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // required
                                    // autoFocus
                                    margin="dense"
                                    id="name"
                                    label="Customer Creation Allowed"
                                    fullWidth
                                    variant="standard"
                                    type="text"
                                    name="isCustCreationAllowed"
                                    value={isCustCreation || ""}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>
                        </Grid>

                        <Grid container spacing={2} style={{ padding: "25px" }}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="text-center themeBackground"
                                    variant="secondary"
                                    fullWidth={true}
                                >
                                    <Typography variant="body1"> Prepaid Card </Typography>
                                </Alert>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    label="Customer Activate Card Required"
                                    fullWidth
                                    variant="standard"
                                    value={customerActivateCardRequired || ""}
                                    name="customerActivateCardRequired"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    label="Prepaid Card Feature Required"
                                    fullWidth
                                    variant="standard"
                                    value={prepaidCardFeatureRequired || ""}
                                    name="prepaidCardFeatureRequired"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y (Allow)</MenuItem>
                                    <MenuItem value="N">N (Not Allow)</MenuItem>
                                    <MenuItem value="D">D (Display and Allow)</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    id="name"
                                    label="
                Applying Prepaid Card During SignUp"
                                    fullWidth
                                    value={applyingPrepaidCardDuringSignUp || ""}
                                    name="applyingPrepaidCardDuringSignUp"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>
                        </Grid>

                        <Grid container spacing={2} style={{ padding: "25px" }}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="text-center themeBackground"
                                    variant="secondary"
                                    fullWidth={true}
                                >
                                    <Typography variant="body1"> Wallet Settings </Typography>
                                </Alert>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    id="name"
                                    label="
                Activity Log Allowed"
                                    fullWidth
                                    variant="standard"
                                    type="text"
                                    value={activityLogAllowed || ""}
                                    name="activityLogAllowed"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y (Allow)</MenuItem>
                                    <MenuItem value="N">N (Not Allow)</MenuItem>
                                    <MenuItem value="D">D (Display and Allow)</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    id="name"
                                    label="
                Wallet Transfer Allowed"
                                    fullWidth
                                    value={walletTransferAllowed || ""}
                                    name="walletTransferAllowed"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y (Allow)</MenuItem>
                                    <MenuItem value="N">N (Not Allow)</MenuItem>
                                    <MenuItem value="D">D (Display and Allow)</MenuItem>
                                </TextField>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    margin="dense"

                                    select
                                    label="
                Loyalty Points Allowed"
                                    fullWidth
                                    variant="standard"
                                    value={loyaltyPointsAllowed || ""}
                                    name="loyaltyPointsAllowed"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y (Allow)</MenuItem>
                                    <MenuItem value="N">N (Not Allow)</MenuItem>
                                    <MenuItem value="D">D (Display and Allow)</MenuItem>
                                </TextField>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    margin="dense"

                                    label="
                Wallet History Allowed"
                                    fullWidth
                                    type="text"
                                    name="walletHistoryAllowed"
                                    value={walletHistoryAllowed || ""}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y (Allow)</MenuItem>
                                    <MenuItem value="N">N (Not Allow)</MenuItem>
                                    <MenuItem value="D">D (Display and Allow)</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // required
                                    // autoFocus
                                    margin="dense"
                                    id="name"
                                    label="
                Integration"
                                    fullWidth
                                    variant="standard"
                                    type="text"
                                    value={integration || ""}
                                    name="integration"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="api">API</MenuItem>
                                    <MenuItem value="checkout">checkout</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    margin="dense"

                                    id="name"
                                    label="Transaction History allowed"
                                    fullWidth
                                    variant="standard"
                                    value={transactionHistoryAllowed || ""}
                                    name="transactionHistoryAllowed"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>


                        </Grid>
                        <Grid container spacing={2} style={{ padding: "25px" }}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="text-center themeBackground"
                                    variant="secondary"
                                    fullWidth={true}
                                >
                                    <Typography variant="body1">Load Configuration</Typography>
                                </Alert>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    id="name"
                                    label="Load Money Allowed"
                                    fullWidth
                                    variant="standard"
                                    name="loadMoneyAllowed"
                                    value={loadMoneyAllowed || ""}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y (Allow)</MenuItem>
                                    <MenuItem value="N">N (Not Allow)</MenuItem>
                                    <MenuItem value="D">D (Display and Allow)</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    label="
                Load with Wallet Allowed"
                                    fullWidth
                                    variant="standard"
                                    value={loadwithWalletAllowed || ""}
                                    name="loadwithWalletAllowed"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    margin="dense"

                                    select
                                    // autoFocus
                                    label="
                Load Security Allowed"
                                    fullWidth
                                    value={loadSecurityAllowed || ""}
                                    name="loadSecurityAllowed"
                                    variant="standard"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>
                        </Grid>

                        <Grid container spacing={2} style={{ padding: "25px" }}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="text-center themeBackground"
                                    variant="secondary"
                                    fullWidth={true}
                                >
                                    <Typography variant="body1">
                                        {" "}
                                        Withdraw Configuration{" "}
                                    </Typography>
                                </Alert>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    id="name"
                                    label="Withdraw Money Allowed"
                                    fullWidth
                                    variant="standard"
                                    type="text"
                                    value={withdrawMoneyAllowed || ""}
                                    name="withdrawMoneyAllowed"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y (Allow)</MenuItem>
                                    <MenuItem value="N">N (Not Allow)</MenuItem>
                                    <MenuItem value="D">D (Display and Allow)</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    id="name"
                                    label="
                Withdraw Verification Allowed"
                                    fullWidth
                                    name="withdrawVerificationAllowed"
                                    value={withdrawVerificationAllowed || ""}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y (Allow)</MenuItem>
                                    <MenuItem value="N">N (Not Allow)</MenuItem>
                                    <MenuItem value="D">D (Display and Allow)</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    id="name"
                                    label="
                withdraw Security Allowed"
                                    fullWidth
                                    value={withdrawSecurityAllowed || ""}
                                    name="withdrawSecurityAllowed"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} style={{ padding: "25px" }}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="text-center themeBackground"
                                    variant="secondary"
                                    fullWidth={true}
                                >
                                    <Typography variant="body1">
                                        {" "}
                                        Send Configuration{" "}
                                    </Typography>
                                </Alert>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    id="name"
                                    label="
                Send Money Allowed"
                                    fullWidth
                                    variant="standard"
                                    value={sendMoneyAllowed || ""}
                                    name="sendMoneyAllowed"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y (Allow)</MenuItem>
                                    <MenuItem value="N">N (Not Allow)</MenuItem>
                                    <MenuItem value="D">D (Display and Allow)</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    id="name"
                                    label="
                Send Money Merchant Required"
                                    fullWidth
                                    name="sendMoneyMerchantRequired"
                                    value={sendMoneyMerchantRequired || ""}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    margin="dense"

                                    // autoFocus
                                    label="
                Send Security Allowed"
                                    fullWidth
                                    variant="standard"
                                    name="sendSecurityAllowed"
                                    onChange={handleChange}
                                    value={sendSecurityAllowed}
                                >
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    margin="dense"

                                    select
                                    label="
                Request Security Allowed"
                                    fullWidth
                                    value={requestSecurityAllowed || ""}
                                    name="requestSecurityAllowed"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    label="
                Request Money Allowed"
                                    fullWidth
                                    variant="standard"
                                    type="text"
                                    value={requestMoneyAllowed || ""}
                                    name="requestMoneyAllowed"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y (Allow)</MenuItem>
                                    <MenuItem value="N">N (Not Allow)</MenuItem>
                                    <MenuItem value="D">D (Display and Allow)</MenuItem>
                                </TextField>
                            </Grid>
                        </Grid>

                        <Grid container spacing={2} style={{ padding: "25px" }}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="text-center themeBackground"
                                    variant="secondary"
                                    fullWidth={true}
                                >
                                    <Typography variant="body1">
                                        {" "}
                                        Pay Configuration{" "}
                                    </Typography>
                                </Alert>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    id="name"
                                    label="
                Pay Allowed"
                                    fullWidth
                                    variant="standard"
                                    value={payAllowed || ""}
                                    name="payAllowed"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y (Allow)</MenuItem>
                                    <MenuItem value="N">N (Not Allow)</MenuItem>
                                    <MenuItem value="D">D (Display and Allow)</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    label="
                Pay Option"
                                    fullWidth
                                    variant="standard"
                                    value={payOption || ""}
                                    name="payOption"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Load">Load</MenuItem>
                                    <MenuItem value="Wallet">Wallet</MenuItem>
                                    <MenuItem value="Wallet Load Auto">Wallet Load Auto</MenuItem>
                                    <MenuItem value="Wallet Load Manual">
                                        Wallet Load Manual
                                    </MenuItem>
                                </TextField>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    margin="dense"

                                    label="
                Pay Security Allowed"
                                    fullWidth
                                    variant="standard"
                                    value={paySecurityAllowed || ""}
                                    name="paySecurityAllowed"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    label="
                Purchase Security Allowed"
                                    fullWidth
                                    value={purchaseSecurityAllowed || ""}
                                    name="purchaseSecurityAllowed"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>
                        </Grid>

                        <Grid container spacing={2} style={{ padding: "25px" }}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="text-center themeBackground"
                                    variant="secondary"
                                    fullWidth={true}
                                >
                                    <Typography variant="body1">
                                        {" "}
                                        Profile Configuration{" "}
                                    </Typography>
                                </Alert>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    margin="dense"

                                    select
                                    label="
                My Card Allowed"
                                    fullWidth
                                    variant="standard"
                                    value={myCardAllowed || ""}
                                    name="myCardAllowed"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y (Allow)</MenuItem>
                                    <MenuItem value="N">N (Not Allow)</MenuItem>
                                    <MenuItem value="D">D (Display and Allow)</MenuItem>
                                </TextField>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    margin="dense"

                                    select
                                    // autoFocus
                                    label="
                My Bank Allowed"
                                    fullWidth
                                    variant="standard"
                                    value={myBankAllowed || ""}
                                    name="myBankAllowed"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y (Allow)</MenuItem>
                                    <MenuItem value="N">N (Not Allow)</MenuItem>
                                    <MenuItem value="D">D (Display and Allow)</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // required
                                    // autoFocus
                                    margin="dense"
                                    label="
                Wallet Allowed"
                                    fullWidth
                                    variant="standard"
                                    type="text"
                                    name="walletAllowed"
                                    value={walletAllowed || ""}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y (Allow)</MenuItem>
                                    <MenuItem value="N">N (Not Allow)</MenuItem>
                                    <MenuItem value="D">D (Display and Allow)</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    margin="dense"

                                    select
                                    // autoFocus
                                    label="
                User Management "
                                    fullWidth
                                    value={userManagement || ""}
                                    name="userManagement"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    margin="dense"

                                    id="name"
                                    label="Store Required  "
                                    fullWidth
                                    variant="standard"
                                    value={storeRequired || ""}
                                    name="storeRequired"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    margin="dense"

                                    id="name"
                                    label="My IBAN Allowed"
                                    fullWidth
                                    variant="standard"
                                    value={myIbanAllowed || ""}
                                    name="myIbanAllowed"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    margin="dense"

                                    id="name"
                                    label="Profile Setting Allowed"
                                    fullWidth
                                    variant="standard"
                                    value={profileSettingsAllowed || ""}
                                    name="profileSettingsAllowed"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    margin="dense"

                                    id="name"
                                    label="SEPA Allowed"
                                    fullWidth
                                    variant="standard"
                                    value={isSEPAAllowed || ""}
                                    name="isSEPAAllowed"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                    <MenuItem value="D">D</MenuItem>
                                </TextField>
                            </Grid>
                        </Grid>

                        <Grid container spacing={2} style={{ padding: "25px" }}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="text-center themeBackground"
                                    variant="secondary"
                                    fullWidth={true}
                                >
                                    <Typography variant="body1">
                                        {" "}
                                        Pay Order Configuration{" "}
                                    </Typography>
                                </Alert>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    label="Pay Order Allowed"
                                    fullWidth
                                    name="payOrderAllowed"
                                    value={payOrderAllowed || ""}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y (Allow)</MenuItem>
                                    <MenuItem value="N">N (Not Allow)</MenuItem>
                                    <MenuItem value="D">D (Display and Allow)</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    label="
                Pay Received Allowed"
                                    fullWidth
                                    variant="standard"
                                    name="payReceivedAllowed"
                                    value={payReceivedAllowed || ""}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y (Allow)</MenuItem>
                                    <MenuItem value="N">N (Not Allow)</MenuItem>
                                    <MenuItem value="D">D (Display and Allow)</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    margin="dense"

                                    // autoFocus
                                    label="
                Pay Order Security Allowed"
                                    value={payOrderSecurityAllowed || ""}
                                    name="payOrderSecurityAllowed"
                                    fullWidth
                                    variant="standard"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>
                        </Grid>

                        <Grid container spacing={2} style={{ padding: "25px" }}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="text-center themeBackground"
                                    variant="secondary"
                                    fullWidth={true}
                                >
                                    <Typography variant="body1">
                                        {" "}
                                        Other Configuration{" "}
                                    </Typography>
                                </Alert>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    label="
CashOut Allowed"
                                    fullWidth
                                    variant="standard"
                                    name="cashoutAllowed"
                                    value={cashoutAllowed || ""}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y (Allow)</MenuItem>
                                    <MenuItem value="N">N (Not Allow)</MenuItem>
                                    <MenuItem value="D">D (Display and Allow)</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    id="name"
                                    label="Check Deposit Allowed"
                                    fullWidth
                                    variant="standard"
                                    name="checkDepositAllowed"
                                    value={checkDepositAllowed || ""}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y (Allow)</MenuItem>
                                    <MenuItem value="N">N (Not Allow)</MenuItem>
                                    <MenuItem value="D">D (Display and Allow)</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    margin="dense"

                                    // autoFocus
                                    label="CashIn Allowed"
                                    fullWidth
                                    name="cashInAllowed"
                                    value={cashInAllowed || ""}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y (Allow)</MenuItem>
                                    <MenuItem value="N">N (Not Allow)</MenuItem>
                                    <MenuItem value="D">D (Display and Allow)</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    margin="dense"

                                    // autoFocus
                                    label="Request CashIn Allowed"
                                    fullWidth
                                    name="requestCashInAllowed"
                                    value={requestCashInAllowed || ""}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y (Allow)</MenuItem>
                                    <MenuItem value="N">N (Not Allow)</MenuItem>
                                    <MenuItem value="D">D (Display and Allow)</MenuItem>
                                    {/* <MenuItem
                  value={requestCashInAllowed}
                  selected={requestCashInAllowed}
                >
                  {requestCashInAllowed}
                </MenuItem> */}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    label="Request CashOut Allowed"
                                    fullWidth
                                    variant="standard"
                                    name="requestCashOutAllowed"
                                    value={requestCashOutAllowed || ""}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y (Allow)</MenuItem>
                                    <MenuItem value="N">N (Not Allow)</MenuItem>
                                    <MenuItem value="D">D (Display and Allow)</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    margin="dense"
                                    select
                                    label="Radio Allowed"
                                    fullWidth
                                    value={radioAllowed || ""}
                                    name="radioAllowed"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y (Allow)</MenuItem>
                                    <MenuItem value="N">N (Not Allow)</MenuItem>
                                    <MenuItem value="D">D (Display and Allow)</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    margin="dense"
                                    label="
                Block Chain Allowed"
                                    fullWidth
                                    variant="standard"
                                    value={blockChainAllowed || ""}
                                    name="blockChainAllowed"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y (Allow)</MenuItem>
                                    <MenuItem value="N">N (Not Allow)</MenuItem>
                                    <MenuItem value="D">D (Display and Allow)</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    margin="dense"
                                    label="
                Recharge Allowed"
                                    fullWidth
                                    variant="standard"
                                    value={rechargeAllowed || ""}
                                    name="rechargeAllowed"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y (Allow)</MenuItem>
                                    <MenuItem value="N">N (Not Allow)</MenuItem>
                                    <MenuItem value="D">D (Display and Allow)</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    margin="dense"
                                    // autoFocus
                                    label="
                Bill Payment Allowed"
                                    fullWidth
                                    variant="standard"
                                    value={billPaymentAllowed || ""}
                                    name="billPaymentAllowed"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y (Allow)</MenuItem>
                                    <MenuItem value="N">N (Not Allow)</MenuItem>
                                    <MenuItem value="D">D (Display and Allow)</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    margin="dense"
                                    label="
                CashOut Security Allowed"
                                    fullWidth
                                    variant="standard"
                                    value={cashoutSecurityAllowed || ""}
                                    name="cashoutSecurityAllowed"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    margin="dense"
                                    label="
                CashIn Security Allowed"
                                    fullWidth
                                    variant="standard"
                                    value={cashinSecurityAllowed || ""}
                                    name="cashinSecurityAllowed"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // required
                                    // autoFocus
                                    margin="dense"
                                    id="name"
                                    label="
                Donation Allowed"
                                    fullWidth
                                    variant="standard"
                                    name="donationAllowed"
                                    value={donationAllowed || ""}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Y">Y (Allow)</MenuItem>
                                    <MenuItem value="N">N (Not Allow)</MenuItem>
                                    <MenuItem value="D">D (Display and Allow)</MenuItem>
                                </TextField>
                            </Grid>
                        </Grid>

                        <Grid container spacing={2} style={{ padding: "25px" }}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="text-center themeBackground"
                                    variant="secondary"
                                    fullWidth={true}
                                >
                                    <Typography variant="body1">
                                        {" "}
                                        Voucher Configuration{" "}
                                    </Typography>
                                </Alert>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    id="name"
                                    label="Voucher Purchase Allowed"
                                    fullWidth
                                    variant="standard"
                                    name="voucherPurchaseAllowed"
                                    onChange={handleChange}
                                    value={voucherPurchaseAllowed || ""}
                                >
                                    {/* <MenuItem
                  value={voucherPurchaseAllowed}
                  selected={voucherPurchaseAllowed}
                >
                  {voucherPurchaseAllowed}
                </MenuItem> */}
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    id="name"
                                    label="Transaction History Allowed"
                                    fullWidth
                                    variant="standard"
                                    value={transactionHistoryAllowedv || ""}
                                    name="transactionHistoryAllowedv"
                                    onChange={handleChange}
                                >
                                    {/* <MenuItem
                  value={transactionHistoryAllowedv}
                  selected={transactionHistoryAllowedv}
                >
                  {transactionHistoryAllowedv}
                </MenuItem> */}
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    id="name"
                                    label="
                My Voucher Allowed"
                                    fullWidth
                                    variant="standard"
                                    value={myVoucherAllowed || ""}
                                    name="myVoucherAllowed"
                                    onChange={handleChange}
                                >
                                    {/* <MenuItem value={myVoucherAllowed} selected={myVoucherAllowed}>
                  {myVoucherAllowed}
                </MenuItem> */}
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    label="Redeem Password Allowed"
                                    fullWidth
                                    variant="standard"
                                    value={redeemPasswordAllowed || ""}
                                    name="redeemPasswordAllowed"
                                    onChange={handleChange}
                                >
                                    {/* <MenuItem
                  value={redeemPasswordAllowed}
                  selected={redeemPasswordAllowed}
                >
                  {redeemPasswordAllowed}
                </MenuItem>{" "} */}
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // required
                                    // autoFocus
                                    margin="dense"
                                    id="name"
                                    label="Redeem Authentication"
                                    fullWidth
                                    variant="standard"
                                    type="text"
                                    value={redeemAuthentication || ""}
                                    name="redeemAuthentication"
                                    onChange={handleChange}
                                >
                                    {/* <MenuItem
                  value={redeemAuthentication}
                  selected={redeemAuthentication}
                >
                  {redeemAuthentication}
                </MenuItem> */}
                                    <MenuItem value="customerEmail">CustomerEmail</MenuItem>
                                    <MenuItem value="customerEmail,customerPassword">
                                        Customer Email & Password
                                    </MenuItem>
                                    <MenuItem value="customerEmail,transactionPassword">
                                        Customer Email & Redeem Password
                                    </MenuItem>
                                    customerEmail,transactionPassword
                                </TextField>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    id="name"
                                    label="Redeem Exact Order Amount"
                                    fullWidth
                                    variant="standard"
                                    value={redeemExactOrderAmount || ""}
                                    name="redeemExactOrderAmount"
                                    onChange={handleChange}
                                >
                                    {/* <MenuItem
                  value={redeemExactOrderAmount}
                  selected={redeemExactOrderAmount}
                >
                  {redeemExactOrderAmount}
                </MenuItem> */}
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    id="name"
                                    label="Settlement Report Required"
                                    fullWidth
                                    variant="standard"
                                    // defaultValue={"Select Order Sell Report Allowed" || role}
                                    name="settlementReportRequired"
                                    value={settlementReportRequired || ""}
                                    onChange={handleChange}
                                >
                                    {/* <MenuItem
                  value={settlementReportRequired}
                  selected={settlementReportRequired}
                >
                  {settlementReportRequired}
                </MenuItem> */}
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    id="name"
                                    label="API Key Required"
                                    fullWidth
                                    variant="standard"
                                    type="text"
                                    name="aPIKeyRequired"
                                    defaultValue={
                                        "Select Order Sell Report Allowed" || aPIKeyRequired
                                    }
                                    value={aPIKeyRequired || ""}
                                    onChange={handleChange}
                                >
                                    {/* <MenuItem value={aPIKeyRequired} selected={aPIKeyRequired}>
                  {aPIKeyRequired}
                </MenuItem> */}
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} style={{ padding: "25px" }}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="text-center themeBackground"
                                    variant="secondary"
                                    fullWidth={true}
                                >
                                    <Typography variant="body1">
                                        {" "}
                                        Bank Configuration{" "}
                                    </Typography>
                                </Alert>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    margin="dense"
                                    id="name"
                                    label="Send To Contact Allowed"
                                    fullWidth
                                    variant="standard"
                                    name="sendToContactAllowed"
                                    onChange={handleChange}
                                    value={sendToContactAllowed || ""}
                                >
                                    <MenuItem value="D">D</MenuItem>
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    margin="dense"
                                    id="name"
                                    label="Send To Self Allowed"
                                    fullWidth
                                    variant="standard"
                                    value={sendToSelfAllowed || ""}
                                    name="sendToSelfAllowed"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="D">D</MenuItem>
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    margin="dense"
                                    id="name"
                                    label="Send To Other Allowed"
                                    fullWidth
                                    variant="standard"
                                    value={sendToOtherAllowed || ""}
                                    name="sendToOtherAllowed"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="D">D</MenuItem>
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    margin="dense"
                                    label="Check Balance Allowed"
                                    fullWidth
                                    variant="standard"
                                    value={checkBalanceAllowed || ""}
                                    name="checkBalanceAllowed"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="D">D</MenuItem>
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    margin="dense"
                                    id="name"
                                    label="Manage Beneficiaries Allowed"
                                    fullWidth
                                    variant="standard"
                                    value={manageBeneficiariesAllowed || ""}
                                    name="manageBeneficiariesAllowed"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="D">D</MenuItem>
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} style={{ padding: "25px" }}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="text-center themeBackground"
                                    variant="secondary"
                                    fullWidth={true}
                                >
                                    <Typography variant="body1">
                                        {" "}
                                        Refund Configuration{" "}
                                    </Typography>
                                </Alert>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    margin="dense"
                                    id="name"
                                    label="Refund"
                                    fullWidth
                                    variant="standard"
                                    name="getRefund"
                                    onChange={handleChange}
                                    value={getRefund || ""}
                                >
                                    <MenuItem value="D">D</MenuItem>
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    margin="dense"
                                    id="name"
                                    label="Partial Refund"
                                    fullWidth
                                    variant="standard"
                                    name="getPartialRefund"
                                    onChange={handleChange}
                                    value={getPartialRefund || ""}
                                >
                                    <MenuItem value="D">D</MenuItem>
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    margin="dense"
                                    id="name"
                                    label="Full Refund"
                                    fullWidth
                                    variant="standard"
                                    name="getFullRefund"
                                    onChange={handleChange}
                                    value={getFullRefund || ""}
                                >
                                    <MenuItem value="D">D</MenuItem>
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>

                        </Grid>
                        <Grid container spacing={2} style={{ padding: "25px" }}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="text-center themeBackground"
                                    variant="secondary"
                                    fullWidth={true}
                                >
                                    <Typography variant="body1">
                                        {" "}
                                        Transaction Configuration{" "}
                                    </Typography>
                                </Alert>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    margin="dense"
                                    id="name"
                                    label="Is Country Selection"
                                    fullWidth
                                    variant="standard"
                                    name="countrySelection"
                                    onChange={handleChange}
                                    value={countrySelection || ""}
                                >
                                    {/* <MenuItem value="D">D</MenuItem> */}
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    margin="dense"
                                    id="name"
                                    label="Is Terms And Conditions"
                                    fullWidth
                                    variant="standard"
                                    name="getIsTermsAndConditions"
                                    onChange={handleChange}
                                    value={getIsTermsAndConditions || ""}
                                >
                                    {/* <MenuItem value="D">D</MenuItem> */}
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>
                            {/* <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    // autoFocus
                                    disabled={getIsTermsAndConditions === "N" ? true : false}
                                    margin="dense"
                                    id="name"
                                    label="Terms URL"
                                    fullWidth
                                    variant="standard"
                                    type="text"
                                    name="getTermsURL"
                                    value={getTermsURL}
                                    onChange={handleChange}
                                />
                            </Grid> */}

                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    margin="dense"
                                    id="name"
                                    label="Is Auto Redirect"
                                    fullWidth
                                    variant="standard"
                                    name="getIsAutoRedirect"
                                    onChange={handleChange}
                                    value={getIsAutoRedirect || ""}
                                >
                                    {/* <MenuItem value="D">D</MenuItem> */}
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    // autoFocus
                                    disabled={getRedirectTime === "N" ? true : false}
                                    margin="dense"
                                    id="name"
                                    label="Enter Time In Millisecond"
                                    fullWidth
                                    variant="standard"
                                    type="text"
                                    name="getRedirectTime"
                                    value={getRedirectTime}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Box style={{ marginTop: "10px" }}>
                                    <Typography>Consent</Typography>
                                    <textarea className="signup-consent" id="w3review" rows="5" style={{ minWidth: '66%' }}
                                        type="text"
                                        name="getTransactionConsent"
                                        value={getTransactionConsent || ""}
                                        onChange={handleChange}
                                    >
                                    </textarea>
                                </Box>
                            </Grid>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            lg={12}
                            style={{ marginLeft: "auto", marginRight: "auto" }}
                        >
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={() => editConfigurationListApi()}
                            >
                                Save
                            </CustomButton>
                        </Grid>
                    </Card>
                )}
            </Layout>
            {updateConfigurationArray.status == "success" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent className="text-center" style={{ backgroundColor: "#00b9f51c" }}>
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {updateConfigurationArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {updateConfigurationArray.status == "failed" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent className="text-center" style={{ backgroundColor: "#00b9f51c" }}>
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {updateConfigurationArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
        </>
    );


}

export default AdminUpdateConfiguration
